import {request} from '@/utils/http';

let activityList = '/fronted/factory/active/list';
let activityDetail = '/fronted/factory/active/detail/'
let subjectDetail = '/fronted/subject/detail'


export function GET_ACTIVITYLIST(params){
  return request(activityList,'get',params)
}
export function GET_ACTIVITYDETAIL(params){
    return request(activityDetail+params,'get',params)
  }
  export function GET_SUBJECTDETAILLIST(params){
    return request(subjectDetail,'get',params)
  }


// WEBPACK FOOTER //
// ./src/api/activity.api.js